export const reportMappings = [
  {
	"label": "Catalogue Number",
	"value": "catalogue_number",
	"required": true
  },
  {
	"label": "Quantity",
	"value": "quantity",
	"required": true
  },
  {
	"label": "Account Number",
	"value": "account_number",
	"required": true
  },
  {
	"label": "Date Shipped",
	"value": "date_shipped",
	"required": true
  },
  {
	"label": "Update Stock (Y/N)",
	"value": "update_stock",
	"required": true
  }
]